<!-- ================管理端-协同备课详情====================-->
<template>
    <div class="admin-create-container">
        <div class="admin-head-container">
            <div class="admin-left-head-container" @click="backList">
                <svg t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#377f7f" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
            </div>
            <div class="admin-right-head-container">协同备课详情</div>
        </div>
        <div class="create-content-container">
            <div class="event-base-info-container">
                <div class="event-part1-l">
                    <div class="event-info-item-auto">
                        <span class="item-span">备课标题：</span>
                        {{ form.title || '--' }}
                    </div>
                    <div class="event-info-item-auto">
                        <span class="item-span">学段·年级·学科：</span>
                        {{ form.periodName || '--' }}•{{ form.gradeName || '--' }}•{{ form.subjectName || '--' }}
                    </div>
                    <div class="event-info-item-auto">
                        <span class="item-span">课题级别：</span>
                        {{ form.lessonLevelName || '--' }}
                    </div>
                    <div class="event-info-item-auto">
                        <span class="item-span">备课状态：</span>
                        {{ formatStatus(form.status, form.discussMode) }}
                    </div>
                    <div class="event-info-item-auto">
                        <span class="item-span">备课研讨：</span>
                        {{ formatDiscussMode(form.discussMode) }}
                    </div>
                    <div class="event-info-item-auto">
                        <span class="item-span">主备人：</span>
                        {{ form.leadUserName || '--' }}
                    </div>
                    <div class="event-info-item-auto">
                        <span class="item-span">协备人：</span>
                        {{ form.teamUserNames || form.teamUserText || '--' }}
                    </div>
                    <div class="event-info-item-auto">
                        <span class="item-span">指导专家：</span>
                        {{ form.guideNames || form.guideUserText || '--' }}
                    </div>
                    <div class="event-info-item-auto">
                        <span class="item-span">备课时段：</span>
                        {{ formatTimeRange(form) }}
                    </div>

                    <div class="info-column-container mt15">
                        <div class="column-title">附件内容</div>
                    </div>

                    <div class="attachment-container">
                        <!-- 初案 -->
                        <div class="attachment-section" v-if="hasCaFiles">
                            <div class="section-header">
                                <span class="section-tag">初案</span>
                            </div>
                            <div class="section-line"></div>
                            <div class="section-body">
                                <template v-for="field in caFileFields" :key="field.key">
                                    <div class="sub-type-block" v-if="form[field.field] && form[field.field].length > 0">
                                        <div class="sub-type-tag">{{ field.label }}</div>
                                        <div class="sub-type-files">
                                            <div class="file-row" v-for="item in form[field.field]" :key="item.fileId">
                                                <div class="file-name" @click="downloadFile(item)">{{ item.fileName }}</div>
                                                <div class="file-actions">
                                                    <div class="file-action" title="预览" @click="viewFile(item)">
                                                        <img class="file-action-icon" src="../../../assets/file/file_view_color.png" alt="">
                                                    </div>
                                                    <div class="file-action" title="下载" @click="downloadFile(item)">
                                                        <img class="file-action-icon" src="../../../assets/file/file_download.png" alt="">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>

                        <!-- 修正案 -->
                        <div class="attachment-section" v-if="form.discussMode == 2 && hasXzaFiles">
                            <div class="section-header">
                                <span class="section-tag">修正案</span>
                            </div>
                            <div class="section-line"></div>
                            <div class="section-body">
                                <template v-for="field in xzaFileFields" :key="field.key">
                                    <div class="sub-type-block" v-if="form[field.field] && form[field.field].length > 0">
                                        <div class="sub-type-tag">{{ field.label }}</div>
                                        <div class="sub-type-files">
                                            <div class="file-row" v-for="item in form[field.field]" :key="item.fileId">
                                                <div class="file-name" @click="downloadFile(item)">{{ item.fileName }}</div>
                                                <div class="file-actions">
                                                    <div class="file-action" title="预览" @click="viewFile(item)">
                                                        <img class="file-action-icon" src="../../../assets/file/file_view_color.png" alt="">
                                                    </div>
                                                    <div class="file-action" title="下载" @click="downloadFile(item)">
                                                        <img class="file-action-icon" src="../../../assets/file/file_download.png" alt="">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>

                        <!-- 共案 -->
                        <div class="attachment-section" v-if="hasGaFiles">
                            <div class="section-header">
                                <span class="section-tag">共案</span>
                            </div>
                            <div class="section-line"></div>
                            <div class="section-body">
                                <template v-for="field in gaFileFields" :key="field.key">
                                    <div class="sub-type-block" v-if="form[field.field] && form[field.field].length > 0">
                                        <div class="sub-type-tag">{{ field.label }}</div>
                                        <div class="sub-type-files">
                                            <div class="file-row" v-for="item in form[field.field]" :key="item.fileId">
                                                <div class="file-name" @click="downloadFile(item)">{{ item.fileName }}</div>
                                                <div class="file-actions">
                                                    <div class="file-action" title="预览" @click="viewFile(item)">
                                                        <img class="file-action-icon" src="../../../assets/file/file_view_color.png" alt="">
                                                    </div>
                                                    <div class="file-action" title="下载" @click="downloadFile(item)">
                                                        <img class="file-action-icon" src="../../../assets/file/file_download.png" alt="">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>

                    <div v-if="!hasCaFiles && !(form.discussMode == 2 && hasXzaFiles) && !hasGaFiles" class="data-empty mt15">
                        <div class="empty-icon"><img src="../../../assets/image/data_empty.png" alt="" /></div>
                        <div class="empty-title">暂无附件</div>
                    </div>
                </div>
                <div class="event-part1-r">
                    <div class="event-info-item-auto">
                        <span class="item-span">备课封面：</span>
                    </div>
                    <div class="event-base-info-cover">
                        <img class="img-100" :src="form.coverUrl" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { lessonInfo } from "@/api/admin/lesson";
import { queryDict } from "@/api/admin/dict";
import { timestampToTime } from "@/utils/date";
import { downloadFile } from "@/utils/download";

export default {
    components: {},
    name: "teamLessonDetail",
    data() {
        return {
            timestampToTime,
            lessonId: '',
            form: {
                title: '',
                periodName: '',
                gradeName: '',
                subjectName: '',
                lessonLevelName: '',
                lessonNature: '',
                discussMode: 1,
                leadUserName: '',
                teamUserNames: '',
                guideNames: '',
                teamUserText: '',
                guideUserText: '',
                beginTime: '',
                endTime: '',
                createTime: '',
                status: '',
                releaseStatus: '',
                coverUrl: '',
                jaFiles: [],
                xaFiles: [],
                kjFiles: [],
                xtFiles: [],
                ytjaFiles: [],
                ytxaFiles: [],
                ytkjFiles: [],
                ytxtFiles: [],
                gajaFiles: [],
                gaxaFiles: [],
                gakjFiles: [],
                gaxtFiles: [],
            },
            caFileFields: [
                { key: 'ja', field: 'jaFiles', label: '教案' },
                { key: 'xa', field: 'xaFiles', label: '学案' },
                { key: 'kj', field: 'kjFiles', label: '课件' },
                { key: 'xt', field: 'xtFiles', label: '习题' },
            ],
            xzaFileFields: [
                { key: 'ytja', field: 'ytjaFiles', label: '教案' },
                { key: 'ytxa', field: 'ytxaFiles', label: '学案' },
                { key: 'ytkj', field: 'ytkjFiles', label: '课件' },
                { key: 'ytxt', field: 'ytxtFiles', label: '习题' },
            ],
            gaFileFields: [
                { key: 'gaja', field: 'gajaFiles', label: '教案' },
                { key: 'gaxa', field: 'gaxaFiles', label: '学案' },
                { key: 'gakj', field: 'gakjFiles', label: '课件' },
                { key: 'gaxt', field: 'gaxtFiles', label: '习题' },
            ],
            natureList: [],
        }
    },
    computed: {
        hasCaFiles() {
            return this.caFileFields.some(f => this.form[f.field] && this.form[f.field].length > 0);
        },
        hasCaFilesContent() {
            return this.hasCaFiles;
        },
        hasXzaFiles() {
            return this.xzaFileFields.some(f => this.form[f.field] && this.form[f.field].length > 0);
        },
        hasXzaFilesContent() {
            return this.hasXzaFiles;
        },
        hasGaFiles() {
            return this.gaFileFields.some(f => this.form[f.field] && this.form[f.field].length > 0);
        },
        hasGaFilesContent() {
            return this.hasGaFiles;
        },
    },
    watch: {},
    created() {
        this.getQueryDict();
        if (this.$route.query.lessonId) {
            this.lessonId = this.$route.query.lessonId
            this.queryLessonInfo()
        }
    },
    mounted() {},
    methods: {
        getQueryDict() {
            queryDict({ code: 'activity_nature' }).then(res => {
                this.natureList = res.data.data || [];
            })
        },
        formatStatus(status, discussMode) {
            if (status === 1) return '初始';
            if (status === 2) return '一轮研讨';
            if (status === 3 && discussMode == 2) return '初案修正';
            if (status === 3 && discussMode == 1) return '共案上传';
            if (status === 4 && discussMode == 2) return '二轮研讨';
            if (status === 5 && discussMode == 2) return '共案修正';
            if (status === 8) return '教学反思';
            if (status === 9) return '备课完成';
            return status || '--';
        },
        formatReleaseStatus(status) {
            if (status === 0) return '未发布';
            if (status === 1) return '审核中';
            if (status === 2) return '已发布';
            if (status === 3) return '已拒绝';
            return status || '--';
        },
        formatDiscussMode(val) {
            if (val == 1) return '一轮研讨';
            if (val == 2) return '二轮研讨';
            return '--';
        },
        formatLessonNature(val) {
            const item = this.natureList.find(s => s.dictKey == val);
            return item ? item.dictValue : (val || '--');
        },
        formatTimeRange(row) {
            if (row.beginTime && row.endTime) {
                return timestampToTime(row.beginTime) + ' 至 ' + timestampToTime(row.endTime);
            }
            return '--';
        },
        backList() {
            this.$router.push({
                path: "/teamLesson",
            });
        },
        queryLessonInfo() {
            lessonInfo({ lessonId: this.lessonId }).then(res => {
                if (res.data.code === 1) {
                    const data = res.data.data || {};
                    this.form = { ...this.form, ...data };
                    // 人员文本处理
                    if (!this.form.teamUserNames) {
                        const textList = [];
                        (this.form.teamUserList || []).forEach(j => {
                            textList.push(j.trueName || j.expertName || '');
                        });
                        this.form.teamUserText = textList.join('、');
                    }
                    if (!this.form.guideNames) {
                        const textList = [];
                        (this.form.guideUserList || []).forEach(j => {
                            textList.push(j.trueName || j.expertName || '');
                        });
                        this.form.guideUserText = textList.join('、');
                    }
                } else {
                    this.$message.error(res.data.msg || "操作失败")
                }
            })
        },
        downloadFile(item) {
            downloadFile(item.fileUrl, item.fileName)
        },
        handleFileStatus(status) {
            if (status !== 1) {
                this.$message.info("文件正在处理，请稍后刷新预览")
            }
        },
        viewFile(item) {
            if (item.status !== 1) {
                this.$message.info("文件正在处理，请稍后刷新预览");
                return;
            }
            if (this.judgeIsPPT(item.fileType)) {
                this.viewPPTFile(item.fileUrl);
            } else {
                const previewList = this.gainFileImgList(item.imgUrl, item.pages);
                if (previewList && previewList.length > 0) {
                    window.open(item.fileUrl, '_blank');
                } else {
                    this.$message.info("暂无可预览内容");
                }
            }
        },
        judgeIsPPT(fileType) {
            return fileType && (fileType.toUpperCase().includes('PPT') || fileType.toUpperCase().includes('POWERPOINT'));
        },
        viewPPTFile(fileUrl) {
            if (fileUrl) {
                window.open(fileUrl, '_blank');
            }
        },
        gainFileImgList(baseUrl, page) {
            const list = [];
            for (let i = 1; i <= page; i++) {
                list.push(baseUrl + '/' + i + '.png');
            }
            return list;
        },
    },
}
</script>
<style scoped>
.info-column-container {
    display: flex;
    width: 100%;
    height: 25px;
    border-bottom: 2px solid #377f7f;
}
.column-title {
    height: 20px;
    line-height: 20px;
    color: #ff9a4c;
    font-weight: bold;
    border-left: 4px solid #377f7f;
    font-size: 16px;
    text-indent: 5px;
    width: 100px;
}
.mt10 {
    margin-top: 10px;
}
.mt15 {
    margin-top: 15px;
}
.event-base-info-container {
    width: 100%;
    height: auto;
    padding-bottom: 10px;
    display: flex;
}
.event-part1-l {
    width: calc(100% - 300px);
    height: 100%;
    padding-right: 20px;
    box-sizing: border-box;
}
.event-info-item-auto {
    width: 100%;
    height: auto;
    line-height: 25px;
    display: flex;
    font-size: 15px;
    margin-top: 5px;
}
.event-part1-r {
    width: 300px;
    height: 100%;
}
.event-base-info-cover {
    width: 270px;
    height: 152px;
    box-sizing: border-box;
}
.event-base-info-cover img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.item-span {
    font-weight: bold;
    color: #377f7f;
    white-space: nowrap;
}
.attachment-container {
    width: 100%;
    padding: 10px 0;
}
.attachment-section {
    margin-bottom: 20px;
}
.section-header {
    margin-bottom: 8px;
}
.section-tag {
    display: inline-block;
    padding: 4px 16px;
    border-radius: 14px;
    font-size: 14px;
    font-weight: bold;
    background-color: #377f7f;
    color: #fff;
}
.section-line {
    width: 100%;
    height: 2px;
    background-color: #377f7f;
    margin-bottom: 12px;
}
.section-body {
    padding-left: 10px;
}
.sub-type-block {
    display: flex;
    align-items: flex-start;
    padding-bottom: 12px;
    margin-bottom: 12px;
    border-bottom: 1px solid #e0e0e0;
}
.sub-type-block:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
}
.sub-type-tag {
    flex-shrink: 0;
    display: inline-block;
    padding: 2px 10px;
    border-radius: 12px;
    background-color: #377f7f;
    color: #fff;
    font-size: 12px;
    margin-right: 15px;
    margin-top: 4px;
}
.sub-type-files {
    flex: 1;
    display: flex;
    flex-direction: column;
}
.file-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 28px;
    padding: 4px 0;
    box-sizing: border-box;
}
.file-name {
    flex: 1;
    font-size: 14px;
    color: #333;
    line-height: 20px;
    cursor: pointer;
    word-break: break-all;
    padding-right: 10px;
}
.file-name:hover {
    color: #377f7f;
    font-weight: bold;
}
.file-actions {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 10px;
}
.file-action {
    width: 20px;
    height: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}
.file-action-icon {
    width: 18px;
    height: 18px;
}
.data-empty {
    width: 100px;
    height: 100px;
    margin: auto;
}
.empty-icon {
    width: 100px;
    height: 40px;
}
.empty-icon img {
    width: 40px;
    height: 40px;
    margin-left: 30px;
}
.empty-title {
    width: 100px;
    font-size: 12px;
    text-align: center;
    color: #999999;
}
.img-100 {
    width: 100%;
    height: 100%;
}
@media (max-width: 1024px) {
    .event-base-info-container { flex-direction: column; }
    .event-part1-l { width: 100%; padding-right: 0; }
    .event-part1-r { width: 100%; margin-top: 20px; }
    .event-base-info-cover { width: 240px; height: 135px; }
    .b-file-list { width: 100%; }
}
</style>
